<template>
  <div class="AddScenario lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddScenario-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddScenario-main lxn-pos-rel">
      <div class="AddScenario-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddScenario_title1}}
          </template>
          <template v-slot:body>
            <div class="AddScenario-wrapper-colors lxn-w100">
              <div @click="activeBoxIndex = 0;" class="AddScenario-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
                <div class="AddScenario-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 1;" class="AddScenario-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
                <div class="AddScenario-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 2;" class="AddScenario-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
                <div class="AddScenario-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 3;" class="AddScenario-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
                <div class="AddScenario-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 4;" class="AddScenario-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
                <div class="AddScenario-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
            </div>
            <div class="AddScenario-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddScenario_text1}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="ScenarioName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.Scenario_namePlaceHolder" inputType="text" />
            </div>
            <div class="AddScenario-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddScenario_text2}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetHub" :dropDownContex="dropDownTargetHub" />
            </div>
          </template>
        </TitleBox>
        <Instruction v-for="(instruction, index) in instructions" ref="conditions" :instructionId="instruction.instructionId" :titleBgColor="titleBgColor" :condition="instruction" :targetHub="targetHub" :bgColor="'#ECECEC'"></Instruction>
        <div class="lxn-margin-auto lxn-margin-top-20 lxn-w100 lxn-display-flex-center"  @click="addInstruction">
          <ButtonIcon :size="30" bgColor="#1EA5DE" icon="plus" iconColor="#ffffff" :padding="10" borderColor="#f6af9d" :onclickEffect="true" />
        </div>
      </div>
      <div class="AddScenario-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddScenario_button}}
        </CustomButton>
      </div>
      <div v-if="isEdit" class="AddSchedule-button lxn-margin-auto lxn-w100">
        <CustomButton @click="deleteScenario" bgColor="#F36C4F" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#F5C7BD" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddSchedule_button3}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import CustomInput from '@/components/CustomInput.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'
import DropDown from '@/components/DropDown.vue'
import NumberInputSpinner from '@/components/NumberInputSpinner.vue'
import AcRemoteController from '@/components/Home/Devices/AcRemoteController.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import Instruction from "@/components/Instruction/Instruction";

var messaging = new Messaging(new Logger(false));

export default {
  name: 'AddScenario',
  components: {
    Instruction,
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    ButtonIcon,
    DropDown,
    NumberInputSpinner,
    AcRemoteController
  },
  data: function () {
    return {
      scenarioId: this.$route.params.scenarioId !== undefined ? parseInt(this.$route.params.scenarioId) : this.newScenarioId(),
      isEdit: this.$route.params.scenarioId !== undefined,
      ScenarioName: '',
      condition: {type: 0, conditions: []},
      instructions: [{type: 0, conditions: []}],
      input1State: '',
      activeBoxIndex: 0,
      outputState: 0,
      targetType: 0,
      targetHub: 0,
    }
  },
  mounted: function () {
    if (this.isEdit){
      this.$store.commit('setAppBusy', true);
      setTimeout(() => {
        const scenario = this.$store.state.scenarios.find(x => x.scenarioId === this.scenarioId)
        this.getHubInstructions(scenario);
      }, 2000)
    }
  },
  watch: {
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    dropDownTargetHub: function () {
      var dropDownTargetHub = {
        name: "AddScenarios-TargetHubs",
        title: this.$store.getters.language.texts.AddScenario_text2,
        selectedIndex: this.targetHub,
        data: []
      };
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        dropDownTargetHub.data.push({
          name: this.$store.state.hubs[i].name,
          icon: "hub",
        })
      }
      return dropDownTargetHub;
    },
  },
  methods: {
    newScenarioId: function () {
      let maxId = 0;
      for (const scenarioId of this.$store.state.scenarios.map(x => x.scenarioId)) {
        if (scenarioId > maxId) maxId = scenarioId
      }
      maxId++
      return maxId;
    },
    addInstruction: function () {
      this.instructions.push({type: 0, conditions: []});
    },
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.ScenarioName === ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.AddScenario_alert1);
      }else {
        const instructions = [];
        this.$refs.conditions.forEach(x => {
          const condition = x.getData();
          if (condition === null){
            return;
          }
          instructions.push(condition)
        });
        this.$store.commit('setAppBusy', true);
        const hub = this.$store.state.hubs[this.targetHub];
        const messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: hub.psk,
          destinationUUID: hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });

        const scenario = {
          name: this.ScenarioName,
          color: this.activeBoxIndex,
          hubUUID: hub.uuid,
          scenarios: [
            {
              scenarioId: this.scenarioId,
              instructionList: instructions
            }
          ]
        };
        this.$store.dispatch('addHubScenario', {
          messagingHook: messagingHook,
          hubUUID: hub.uuid,
          scenarios: scenario.scenarios,
        })
            .then( (response) => {
              this.$store.commit(this.isEdit ? 'updateScenario' : 'addScenario', {
                name: scenario.name,
                color: scenario.color,
                hubUUID: hub.uuid,
                scenarioId: this.scenarioId,
              });
              this.$store.commit("saveState");
              this.$router.push('/home/scenarios');
            })
            .catch(response => {
              if(response.rejectCode === 2){
                this.$store.commit('setHubStatus', {
                  hubIndex: response.hubIndex,
                  connectionStatus: {
                    local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                    online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  },
                });
              }
              this.$store.commit('setAppBusy', false);
            })
      }
    },
    getHubInstructions: function (scenarioState) {
      const hub = this.$store.state.hubs.find(x => x.uuid === scenarioState.hubUUID);
      const psk = hub.psk;
      const destinationUUID = hub.uuid;
      const messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: psk,
        destinationUUID: destinationUUID,
        sourceUUID: this.$store.state.user.uuid
      });
      this.$store.dispatch('getHubScenarios', {
        messagingHook: messagingHook,
        hubUUID: destinationUUID,
      })
          .then(response => {
            const scenario = response.body.bodyContent.scenarioList.find(x => x.scenarioId === this.scenarioId);
            this.ScenarioName = scenarioState.name;
            this.activeBoxIndex = scenarioState.color;
            this.targetHub = hub.index;
            scenario.instructionList.forEach(x => {
              this.instructions.push({type: 0, conditions: []});
            });
            setTimeout(() => {
              this.$refs.conditions.forEach((x, i) => x.setData(scenario.instructionList[i]));
            }, 100)
            this.$store.commit('setAppBusy', false);
          })
          .catch( response => {
            if(response.rejectCode === 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
              this.$store.commit('setAppBusy', false);
            }
          });
    },
    deleteScenario: async function () {
      const hub = this.$store.state.hubs[this.targetHub];
      const messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: hub.psk,
        destinationUUID: hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      this.$store.dispatch('removeHubScenario', {
        messagingHook: messagingHook,
        hubUUID: hub.uuid,
        scenarios: [this.scenarioId],
      })
          .then( () => {
            this.$store.commit('deleteScenario', this.scenarioId);
            this.$store.commit("saveState");
            this.$router.push('/home/scenarios');
            this.$store.commit('setAppBusy', false);
          })
          .catch(response => {
            if(response.rejectCode === 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
            this.$store.commit('setAppBusy', false);
          })
    },
  }
}
</script>

<style>
  .AddScenario-topCurve-wrapper {
    height: 200px;
  }
  .AddScenario-main {
    z-index: 2;
  }
  .AddScenario-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .AddScenario-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .AddScenario-wrapper-colors {
    height: 50px;
  }
  .AddScenario-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .AddScenario-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .AddScenario-color.active .AddScenario-selectedColor {
    opacity: 1;
  }
  .AddScenario-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .AddScenario-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .AddScenario-wrapper-padding-0 {
    padding: 0;
    height: unset;
  }
  .AddScenario-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .AddScenario-commandDelay-button {
    -webkit-appearance: none;
    transition: opacity 0.5s ease;
    background: #1EA5DE;
    border: 0;
    border-radius: 7px;
    overflow: hidden;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    width: 40px;
  }
  .AddScenario-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddScenario-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddScenario-commandDelay-button:focus {
      outline: 0;
      outline-offset: 0;
  }
  .AddScenario-wrapper-button2 {
    width: calc(100% - 36px);
    margin-top: 25px;
    margin-bottom: 14px;
  }
  .AddScenario-wrapper-commands {
    height: 70px;
    background-color: #FFFFFF;
    padding: 5px;
    margin-top: 14px;
  }
  .AddScenario-wrapper-commands:first-child {
    margin-top: 0;
  }
  .AddScenario-wrapper-command {
    height: 20px;
    line-height: 20px;
  }
  .AddScenario-wrapper-commands-trash {
    left: 5px;
    top: 5px;
    width: 30px;
    height: 30px;
  }
</style>
